export default "__VITE_ASSET__CyHbJYzH__"